<template>
    <div>
        <el-form :inline="true" ref="form">

            <el-form-item label="ID:" class="query-form-item">
                <el-input style="width: 100px;" clearable v-model="query.id" placeholder="请输入ID"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="国家" prop="state">
                <el-select v-model="query.state" style="width: 100px;" size="mini" filterable>
                    <el-option
                        v-for="item in $common.us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入ASIN"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="父ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.parent_asin" placeholder="请输入父ASIN"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="品名:" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.product_name" placeholder="请输入品名"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="是否有专利值:" class="query-form-item">
                <el-select v-model="query.has_patent_value" placeholder="状态" size="mini" style="width: 100px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="没有" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="标品类型：" class="query-form-item">
                <el-select v-model="query.standard_product_type" placeholder="标品类型" size="mini"
                           style="width: 110px;">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in standardProductTypeArr"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选品原则：" class="query-form-item">
                <el-select v-model="query.selection_principle" placeholder="选品原则" size="mini" style="width: 110px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in selectionPrincipleList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否季节性：" class="query-form-item">
                <el-select v-model="query.is_seasonality" placeholder="季节性" size="mini" style="width: 100px;">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="季节：" class="query-form-item">
                <el-select v-model="query.season" placeholder="请选择" size="mini" filterable style="width: 100px;">
                    <el-option :label="item.label" :value="item.value" v-for="item in $common.seasonArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="FBA费用是否核对：" class="query-form-item">
                <el-select v-model="query.check_fba_charge" size="mini" style="width: 100px">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in fbaCollateArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否主卖：">
                <el-select v-model="query.is_main_seller" placeholder="是否主卖" size="mini" style="width: 100px">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未核对" :value="-1"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="包装核对：" class="query-form-item">
                <el-select v-model="query.check_packing" placeholder="包装核对" size="mini" style="width: 100px">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in collateArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="价格核对：" class="query-form-item">
                <el-select v-model="query.is_market_lowest_price" placeholder="价格核对" size="mini"
                           style="width: 100px">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in isLowPrice"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="vine情况：" class="query-form-item">
                <el-select v-model="query.vine_status" placeholder="vine情况" size="mini" style="width: 100px">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in vineStatusArr"></el-option>
                </el-select>
            </el-form-item>

            <form-range-item :queryTemp="query" ref="formRangeItem"></form-range-item>

            <el-button type="primary" @click="onSubmit" size="mini" style="margin-top: 5px">查询</el-button>
        </el-form>
        <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.operator_asin_img_url">
                        <img style="width:90px;height:90px;" src="../../assets/image/noPic.png"/>
                    </div>
                    <img style="width:90px;height:90px;" :src="scope.row.operator_asin_img_url" v-else/>
                </template>
            </el-table-column>

            <table-asin-column></table-asin-column>

            <el-table-column width="110" align="center" label="父asin">
                <template slot-scope="scope">
                    <span>{{ scope.row.parent_asin }}</span>
                </template>
            </el-table-column>

            <!--            <el-table-column label="负责人" width="100" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div>-->
            <!--                        {{ scope.row.operation_username }} <br/>-->
            <!--                        {{ scope.row.operation_full_name }}-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->

            <el-table-column label="基础信息" width="400" align="center">
                <template slot-scope="scope">
                    <div style="text-align: left">
                        <div style="font-size: 16px; font-weight: 600;">{{ scope.row.title }}</div>
                        <div style="display: flex" v-show="scope.row.rating">
                            <el-rate
                                v-model="scope.row.ratingNum"
                                disabled
                                text-color="#ff9900"
                            >
                            </el-rate>
                            <div style="color: rgb(247, 186, 42)">{{ scope.row.rating }}</div>
                        </div>
                        <div style="font-size: 15px; font-weight: 600;">{{ scope.row.price }}</div>
                        <div style="font-size: 12px; font-weight: 600;">
                            更新时间：{{ scope.row.last_keepa_update_time }}
                        </div>
                        <div style="font-size: 12px; font-weight: 600;">品牌：{{ scope.row.brand }}</div>
                        <div style="font-size: 12px; font-weight: 600;">评论数：{{ scope.row.rating_count }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column width="200" align="center" label="品名">
                <template slot-scope="scope">
                    <span>{{ scope.row.product_name }}</span>
                    <div>
                        铺货: {{ scope.row.is_launch == 1 ? '是' : '否' }} <br/>
                        主卖色: {{ scope.row.is_main_seller == 1 ? '是' : '否' }} <br/>
                        首单日期: {{ scope.row.first_order_time || '-' }} <br/>
                    </div>
                </template>
            </el-table-column>

            <el-table-column width="200" align="center" label="不再运营时间">
                <template slot-scope="scope">
                    <span>{{ scope.row.no_time }}</span>
                </template>
            </el-table-column>
            <el-table-column width="200" align="center" label="不再运营原因">
                <template slot-scope="scope">
                    <div>{{ scope.row.no_season }}</div>
                </template>
            </el-table-column>
            <el-table-column label="利润" min-width="190" align="center">
                <template slot-scope="scope">
                    <div @click="previewProfit(scope.row)" class="" class="zoom">
                        含税：{{ scope.row.early_profit }} <br/>
                        免税：{{ scope.row.early_profit_no_tax }}<br/>
                        利润率(含税)：{{
                            scope.row['profit_rate'] ? accMul(scope.row['profit_rate'], 100) + '%' : '-'
                        }} <br/>
                        利润率(免税)：{{
                            scope.row['profit_rate_no_tax'] ? accMul(scope.row['profit_rate_no_tax'], 100) + '%' : '-'
                        }}<br/>
                        亚马逊物流配送费: {{ scope.row.delivery_charge }} <br/>
                    </div>
                </template>
            </el-table-column>

            <check-info/>


            <el-table-column label="发货方式" min-width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.deliver_mode }}</div>
                </template>
            </el-table-column>

            <el-table-column label="专利" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini">{{ scope.row.patent_value ? scope.row.patent_value : '-' }}
                    </el-button>
                    <br/><br/>
                    <el-button type="success" @click="downFile(scope.row.patent_file)" size="mini"
                               :disabled="!scope.row.patent_file">下载
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="备注" align="center" :show-overflow-tooltip="true" width="220">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="100" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" @click="resumeOperation(scope.row)" size="mini">恢复运营中</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :page-size="query.limit" :current-page="query.page"
                       :page-sizes="[20, 50, 100]" :total="query.total" background
                       style="float: right;margin-top: 10px;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <uploadDom :visible="addSubLibraryModal" @close-callback="closeCllback"
                   title="上传"/>
        <car-modal ref="card" @close-callback="closeCllback"></car-modal>
        <fba-modal ref="fbaModal" @close-callback="closeCllback"></fba-modal>
        <updatePatent ref="updatePatentDom" @close-callback="closeCllback"></updatePatent>
        <noSeasonModal ref="noSeasonModalRef" @close-callback="closeCllback"></noSeasonModal>
        <updateAcosDom ref="updateAcosRef" @close-callback="closeCllback"></updateAcosDom>

    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {downloadFileUrl} from '@/utils/method'
import uploadDom from './depend/upload'
import carModal from './depend/carModal'
import fbaModal from './depend/fbaModal'
import updatePatent from '../costAnalysis/components/updatePatent'
import updateAcosDom from './depend/updateAcos'
import noSeasonModal from './depend/noSeasonModal'
import checkInfo from '@/components/common/checkInfo.vue'

export default {
    components: {checkInfo, uploadDom, carModal, fbaModal, updatePatent, updateAcosDom, noSeasonModal},
    data() {
        return {
            teambitionList: {},

            sevenDaysRange: '',
            fourteenDaysRange: '',
            thirtyDaysRange: '',

            recheckLoading: false,
            vineStatusArr: [
                {name: '全部', value: ''},
                {name: '未申请', value: '未申请'},
                {name: '申请中', value: '申请中'},
                {name: '完成', value: '完成'},
                {name: '老品', value: '老品'},
            ],
            selectionPrincipleList: [],

            standardProductTypeArr: [
                {name: '全部', value: ''},
                {name: '未录入', value: -1},
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
            fbaCollateArr: [
                {name: '全部', value: ''},
                {name: '待核对', value: 0},
                {name: '已核对', value: 1},
                {name: '核对有误', value: -1},
            ],
            collateArr: [
                {name: '全部', value: ''},
                {name: '已核对', value: 1},
                {name: '未核对', value: 0},
            ],
            isLowPrice: [
                {name: '全部', value: ''},
                {name: '是', value: 1},
                {name: '否', value: 0},
            ],
            addSubLibraryModal: false,

            editType: 0,
            manualRootShow: false,
            tableHeight: null,
            managerAnalysisList: [],
            query: {
                id: '',
                state: '',
                asin: '',
                parent_asin: '',
                product_name: '',
                standard_product_type: '',
                check_fba_charge: '',
                check_packing: '',
                is_market_lowest_price: '',
                vine_status: '',
                operation_id: '',

                page: 1,
                limit: 20,
                total: 0,
            },

            list: [],
            disabled: false,
            loading: false,
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
        this.getList()
        this.setDateRanges()
        this.initFunc()

    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        }
    },
    methods: {
        initFunc() {
            api.get_tfs_name_lists().then((res) => {
                if (res.success) {
                    this.teambitionList = res.data
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            })
            api.cost_analysis_selfbuild_get_selection_principle().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.selectionPrincipleList = (res.data || []).map(item => {
                        return {name: item, value: item}
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        formatDate(date) {
            return date.toISOString().split('T')[0] // 格式化日期为 "YYYY-MM-DD"
        },
        setDateRanges() {
            const today = new Date()
            const yesterday = new Date(today)
            yesterday.setDate(today.getDate() - 1) // 昨天的日期

            // 7日内
            const sevenDaysAgo = new Date(yesterday)
            sevenDaysAgo.setDate(yesterday.getDate() - 6) // 7天前的日期

            // 14日内
            const fourteenDaysAgo = new Date(yesterday)
            fourteenDaysAgo.setDate(yesterday.getDate() - 13) // 14天前的日期

            // 30日内
            const thirtyDaysAgo = new Date(yesterday)
            thirtyDaysAgo.setDate(yesterday.getDate() - 29) // 30天前的日期

            // 格式化并赋值给data
            this.sevenDaysRange = `${this.formatDate(sevenDaysAgo)} - ${this.formatDate(yesterday)}`
            this.fourteenDaysRange = `${this.formatDate(fourteenDaysAgo)} - ${this.formatDate(yesterday)}`
            this.thirtyDaysRange = `${this.formatDate(thirtyDaysAgo)} - ${this.formatDate(yesterday)}`
        },

        updateAcos(data) {
            this.$refs.updateAcosRef.openModal(data)
        },
        uploadPatentFile(data) {
            this.$refs.updatePatentDom.openModal(2, data)
        },
        updateVal(data) {
            this.$refs.updatePatentDom.openModal(1, data)
        },

        resumeOperation(data) {
            api.operating_asin_manager_index_return_operating({id: data.id}).then(res => {
                if (res.success) {
                    this.$message.success('已恢复运营')
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
            })
        },
        recheck(data) {
            this.recheckLoading = true
            api.operating_asin_manager_index_recalibrate_fba_charge({id: data.id}).then(res => {
                if (res.success) {
                    this.$message.success('核对成功')
                    this.getList()
                } else {
                    this.$notify({title: '提示', message: res.message, duration: 5000})
                }
            }).finally(() => {
                this.recheckLoading = false
            })
        },
        showFbaModal(arr) {
            if (arr.length > 0) {
                this.$refs.fbaModal.showModal(arr)
            }
        },
        noSeason(data) {
            console.log('data', data)
            this.$refs.noSeasonModalRef.openModal(data)
        },
        previewProfit(data) {
            api.operating_asin_manager_index_get_cost_analysis_data({id: data.id}).then(res => {
                if (res.success) {
                    let resData = res.data
                    resData.refund_rate = this.accMul(resData.refund_rate, 100)
                    this.$refs.card.showModal(resData, JSON.parse(JSON.stringify(data)), 1)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            })
        },
        jumpUrl(data) {
            let url = ''
            if (data.state == 'us') {
                url = 'https://www.amazon.com/dp/' + data.asin
            } else if (data.state == 'uk') {
                url = 'https://www.amazon.co.uk/dp/' + data.asin
            } else if (data.state == 'de') {
                url = 'https://www.amazon.de/dp/' + data.asin
            }
            window.open(url, '_blank')
        },
        uploadFunc() {
            this.addSubLibraryModal = true
        },
        closeCllback(refresh) {
            this.addSubLibraryModal = false

            refresh == true && this.getList()
        },
        updateFunc(data) {
            this.$refs.itemInfo.openModal(3, JSON.parse(JSON.stringify(data)))
        },
        delete_records(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.branch_warehouse_manager_delete({id: data.id}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        getUpdateStatus(data) {
            api.branch_warehouse_line_get_update_status({id: data.id}).then((res) => {
                const h = this.$createElement
                this.$notify({
                    title: '提示',
                    message: h('i', {style: 'color: teal'}, res.data || ''),
                    duration: 5000
                })
            }).catch(res => {
                this.$message({type: 'error', message: res.message})
            })
        },
        getPeaple_records(data) {
            this.subLibraryDetailInfo = data
            this.peopleListVisible = true
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.alibaba_err_msg
        },
        showManualRoot(info) {
            this.manualRootShow = true
            this.manualRootList = info
        },
        getList() {
            this.loading = true
            const tempQuery = this.$refs.formRangeItem.handleQueryData()

            api.operating_asin_manager_index_personal_nolonger_operating_asin_list(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = (res.data.list || []).map(item => {
                        let maxSale = ''
                        let maxTransit = ''
                        if (item.fba_datas && item.fba_datas.length > 0) {
                            let sortSale = (item.fba_datas || []).sort((a, b) => b.fba_sale_quantity - a.fba_sale_quantity)
                            maxSale = sortSale[0].shopname
                            let sortTransit = (item.fba_datas || []).sort((a, b) => b.fba_transit_quantity - a.fba_transit_quantity)
                            maxTransit = sortTransit[0].shopname
                        }
                        item.maxSale = maxSale
                        item.maxTransit = maxTransit
                        return item
                    })
                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '颜色', '不再运营原因'].includes(column.label)) {
                // this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.categoryTree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '不再运营原因') {
                    this.noSeason(row)
                }
                // this.childInfo.info = info
                // this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                state: '',
                asin: '',
                product_name: '',
                standard_product_type: '',
                check_fba_charge: '',
                check_packing: '',
                is_market_lowest_price: '',
                vine_status: '',
                operation_id: '',

                page: 1,
                limit: 20,
                total: 0,
            }
            this.getList()
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 类目列表
        categoryList() {
            this.showCategoryList = true
        },
        upadteRanking() {
            this.upadteRankingModal = true
        },
        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        goBackList() {
            this.showPageType = 0
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>

.zoom {
    cursor: pointer; /* 改变鼠标指针为手指形状 */
}

.zoom:hover {
    cursor: zoom-in; /* 鼠标悬停时变成放大镜图标 */
}

.basicInfo {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 5px;
}

.redClass {
    color: red;
    font-weight: bold;
}

.greenClass {
    color: green;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}

/deep/ .el-form-item {
    margin-bottom: 8px !important;
}

.smallTxt {
    color: #cccccc;
    font-size: 11px;
}
</style>
